import React from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext/AuthContext'
import { profileRoute } from '../../views/Profile/route.const'

interface UnauthenticatedRouteProps extends RouteProps {
    children?: React.ReactNode
}

const UnauthenticatedRoute: React.FC<UnauthenticatedRouteProps> = ({ children, ...rest }) => {
    const { isLoggedIn } = useAuth()

    return (
        <Route
            {...rest}
            render={({ location }) =>
                isLoggedIn ? (
                    <Redirect
                        to={{
                            pathname: profileRoute(),
                            state: { from: location }
                        }}
                    />
                ) : (
                    children
                )
            }
        />
    )
}

export default UnauthenticatedRoute
